import React from "react";
import { connect } from "react-redux";
import routes from "../../assets/apiRoutes.json"
import { GridLayout } from "../../common/GridLayout";
import ModuleTagBoxComponent from './ModuleTagBoxComponent.js';
import RoleTagBoxComponent from './RoleTagBoxComponent.js';
import ArrayStore from "devextreme/data/array_store";


import DataGrid, {
  Column,
  Editing,
  Paging,
  Selection,
  Toolbar,
  Item,
  FilterRow,
  FilterPanel,
  FilterBuilderPopup,
  ColumnChooser,
  ColumnChooserSearch,
  ColumnFixing,
  Sorting,
  Export,
  Pager,
  HeaderFilter,
  StateStoring,
  Lookup
} from 'devextreme-react/data-grid';

import { Button } from 'devextreme-react/button';
import { alert } from 'devextreme/ui/dialog';
import { confirm } from 'devextreme/ui/dialog';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import GridLayoutManager from "../../gridLayoutCustomization/GridLayoutManager";

const filterBuilderPopupPosition = {
  of: window,
  at: 'top',
  my: 'top',
  offset: { y: 10 },
};

const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
const dataGrid = React.createRef();
let accessToken = '';

const gridKey = "38a7d250-1399-4653-a9cd-fff184ad35c3";
const loadState = () => {return GridLayout.sendStorageRequest(gridKey, "GET", accessToken);}

const modules = [
  { Module: "AC" },
  { Module: "AP" },
  { Module: "AR" },
  { Module: "CA" },
  { Module: "DD" },
  { Module: "CM" },
  { Module: "ED" },
  { Module: "EF" },
  { Module: "FA" },
  { Module: "FM" },
  { Module: "GL" },
  { Module: "FM" },
  { Module: "HR" },
  { Module: "FM" },
  { Module: "ID" },
  { Module: "IM" },
  { Module: "OM" },
  { Module: "PI" },
  { Module: "PM" },
  { Module: "PR" },
  { Module: "RM" },
  { Module: "RT" },
  { Module: "SI" },
  { Module: "SM" },
  { Module: "SP" },
  { Module: "TM" },
  { Module: "WM" },
  { Module: "XM" }
];


const modulesDataSource = new ArrayStore({
  data: modules,
  key: "Module",
});

class ARTReportConfiguration extends React.Component {

  constructor(props) {
    super(props);

    accessToken = props.oidc.user.access_token;
    this.onContentReady = this.onContentReady.bind(this);
    this.dataSource = createStore({
      key: 'rowid',
      loadUrl: `${window._env_.REACT_APP_APIS}/${routes.reports.GetArtReports}`,
      updateUrl: `${window._env_.REACT_APP_APIS}/${routes.reports.UpdateArtReport}`,
      onBeforeSend: function(method, ajaxOptions) {
        ajaxOptions.headers = {
          Authorization: `Bearer ${accessToken}`
        };
      }
    });

    this.rolesDataSource = createStore({
      key: 'name',
      loadUrl: `${window._env_.REACT_APP_AUTH_URL}/${routes.idp.loadRoles}`,
      onBeforeSend: function(method, ajaxOptions) {
        ajaxOptions.headers = {
          Authorization: `Bearer ${accessToken}`
        };
      }
    });
    this.state = {
      currentLayout: "Default",
    };
  }
  setCurrentLayout =(value)=>{
    this.setState({
      currentLayout:value
    })
  }
  saveState=(state)=> { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, this.state.currentLayout);}
  render() {
    return (
      <div className="h-100 m-0" style={{ height: '100%',overflowY: 'hidden' }}>
        <div className="title">
                        <h6
                          style={{
                            color: window._env_.Color2
                          }}
                        >
                          Configuration
                        </h6>
                      </div>
       
       <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }} id="gridContainer"
          onContentReady={this.onContentReady}
          ref={dataGrid}
          showBorders={true}
          className="ATConfigurationGridStyle"
          rowAlternationEnabled={true}
          allowColumnResizing={true}
          allowColumnReordering={true}
          columnAutoWidth={true}
        >
          <Selection mode="multiple" />
          <Paging
            enabled={true}
          />
          <Pager
            visible={true}
            showPageSizeSelector={true}
            allowedPageSizes={allowedPageSizes}
            showNavigationButtons={true}
            showInfo={true}
          />
          <FilterRow visible={true} />
          <FilterPanel visible={true} />
          <FilterBuilderPopup position={filterBuilderPopupPosition} />
          <ColumnChooser
            enabled={true}
            title="Choose Column"
            width={290}
            height={290}
            sortOrder="asc"
          >
            <ColumnChooserSearch
              enabled={true}
              editorOptions={{ placeholder: 'Search column' }} />
          </ColumnChooser>
          <HeaderFilter visible={true} />
          <ColumnFixing enabled={true}/>,
          <Export enabled={true} allowExportSelectedData={true} text="Export" />
          <Sorting mode="multiple"/>
          <Editing
            mode="cell"
            newRowPosition="first"
            refreshMode="repaint"
            allowUpdating={true}
            allowAdding={false}
            allowDeleting={false} />
          <StateStoring
            enabled={true}
            type="custom"
            customLoad={loadState}
            storageKey={gridKey}
            customSave={this.saveState}
          />
          <Column dataField="layoutname" caption="Name" allowEditing={false} cssClass="column-readonly"/>
          <Column dataField="assignedmodules" caption="Modules List" allowSorting={false}
            editCellComponent={ModuleTagBoxComponent}
            cellTemplate={this.moduleCellTemplate}
            calculateFilterExpression={this.moduleCalculateFilterExpression}>
              <Lookup
                dataSource={modulesDataSource}
                valueExpr="Module"
                displayExpr="Module"
              />
          </Column>
          <Column dataField="assignedwebroles" caption="Web Role" allowSorting={false}
            editCellComponent={RoleTagBoxComponent}
            cellTemplate={this.roleCellTemplate}
            calculateFilterExpression={this.roleCalculateFilterExpression}>
              <Lookup
                dataSource={this.rolesDataSource}
                valueExpr="name"
                displayExpr="name"
              />
          </Column>
          
          <Toolbar>
          <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={this.setCurrentLayout} />
                 </Item>
            <Item name="exportButton" />
            <Item name="columnChooserButton"/>
          </Toolbar>
        </DataGrid>
      </div>
    );
  }

  onContentReady(e) {
    if (!e.component._hasLoaded) {
      e.component._hasLoaded = true;
      e.component.option("dataSource", this.dataSource);
    }
  }

  moduleCellTemplate(container, options) {
    const noBreakSpace = '\u00A0';
    const text = (options.value || []).map((element) => options.column.lookup.calculateCellValue(element)).join(', ');
    container.textContent = text || noBreakSpace;
    container.title = text;
  }

  moduleCalculateFilterExpression(filterValue, selectedFilterOperation, target) {
    if (target === 'search' && typeof (filterValue) === 'string') {
      return [this.dataField, 'contains', filterValue];
    }
    return function(data) {
      return (data.assignedmodules || []).indexOf(filterValue) !== -1;
    };
  }

  roleCellTemplate(container, options) {
    const noBreakSpace = '\u00A0';
    const text = (options.value || []).map((element) => options.column.lookup.calculateCellValue(element)).join(', ');
    container.textContent = text || noBreakSpace;
    container.title = text;
  }

  roleCalculateFilterExpression(filterValue, selectedFilterOperation, target) {
    if (target === 'search' && typeof (filterValue) === 'string') {
      return [this.dataField, 'contains', filterValue];
    }
    return function(data) {
      return (data.assignedwebroles || []).indexOf(filterValue) !== -1;
    };
  }
 
}

function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}

export default connect(mapStateToProps)(ARTReportConfiguration);
